import referralService from './referralService';

export const ACQUISITION_SESSION_KEY = 'rely_acquisition_session';
export const ACQUISITION_PARAM_KEYS = [
  'ref',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

function getLocationSnapshot(locationOverride) {
  if (locationOverride) {
    return locationOverride;
  }

  if (typeof window !== 'undefined' && window.location) {
    return window.location;
  }

  return {
    pathname: '/',
    search: '',
  };
}

function getSessionStorage(storageOverride) {
  if (storageOverride) {
    return storageOverride;
  }

  if (typeof window !== 'undefined' && window.sessionStorage) {
    return window.sessionStorage;
  }

  return null;
}

function normalizeString(value) {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function buildLandingPath(location) {
  return `${location.pathname || '/'}${location.search || ''}`;
}

function extractAcquisitionParams(search) {
  const searchParams = new URLSearchParams(search || '');

  return Object.fromEntries(
    ACQUISITION_PARAM_KEYS.map((key) => [key, normalizeString(searchParams.get(key))])
  );
}

function normalizeStoredSession(value) {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const normalized = {
    landing_path: normalizeString(value.landing_path) || '/',
    captured_at: normalizeString(value.captured_at),
  };

  for (const key of ACQUISITION_PARAM_KEYS) {
    normalized[key] = normalizeString(value[key]);
  }

  return normalized;
}

export function readAcquisitionSession(options = {}) {
  const storage = getSessionStorage(options.storage);
  if (!storage) {
    return null;
  }

  const raw = storage.getItem(ACQUISITION_SESSION_KEY);
  if (!raw) {
    return null;
  }

  try {
    return normalizeStoredSession(JSON.parse(raw));
  } catch (_error) {
    storage.removeItem(ACQUISITION_SESSION_KEY);
    return null;
  }
}

export function captureAcquisitionSession(options = {}) {
  const storage = getSessionStorage(options.storage);
  const location = getLocationSnapshot(options.location);
  const storedSession = readAcquisitionSession({ storage });
  const currentParams = extractAcquisitionParams(location.search);

  const snapshot = {
    landing_path: storedSession?.landing_path || buildLandingPath(location),
    captured_at:
      storedSession?.captured_at || options.capturedAt || new Date().toISOString(),
  };

  for (const key of ACQUISITION_PARAM_KEYS) {
    snapshot[key] = storedSession?.[key] || currentParams[key];
  }

  if (storage) {
    storage.setItem(ACQUISITION_SESSION_KEY, JSON.stringify(snapshot));
  }

  if (snapshot.ref && options.persistReferral !== false) {
    referralService.storeReferralCode(snapshot.ref);
  }

  return snapshot;
}

export function clearAcquisitionSession(options = {}) {
  const storage = getSessionStorage(options.storage);
  storage?.removeItem(ACQUISITION_SESSION_KEY);
}
